import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

// const ifNotAuthenticated = (to, from, next) => {
  

  // let token =  localStorage.getItem('token');
  // // let role = store.getters['authModule/getUserRole'];
  // // console.log(token);
  //   if (token) {
  //     next()
  //     return
  //   }
  //   next('/')
    
  // }


const routes = [
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import(/* webpackChunkName: "about" */ '../../src/components/uploadfile.vue'),
  //   meta: { requiresAuth: false }, // Set this meta field to false for login page
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: { requiresAuth: false }, // Set this meta field to false for login page
  },
  {
    path: '/dashboard',
    name: 'admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Dashboard.vue'),
    meta: { requiresAuth: true }, // Set this meta field to false for login page
  },
  {
    path: '/schedule',
    name: 'tfe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/tfe.vue'),
    meta: { requiresAuth: true }, // Set this meta field to false for login page
  },
  {
    path: '/View',
    name: 'schedules',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/schedules.vue'),
    meta: { requiresAuth: true }, // Set this meta field to false for login page
  },
  // {
  //   path: '/',
  //   name: 'mainte',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../components/mainte.vue')
  // }
  {
    path: '/',
    /* eslint-disable */
    redirect: to => {
      return '/login'
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // ADD EACH ROUTES IF REQUIRE AUTH.
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // CHECK IF NOT AUTHENTICATED
  if (requiresAuth && !isLoggedIn()) {
    // REDIRECT TO LOGIN
    next({ path: '/login' });
  } else if (!requiresAuth && isLoggedIn()) {
    // IF AUTHENTICATED THEN USER TRYING TO ACCESS LOGIN OR BACK BUTTON FOR LOGIN IT WILL REDIRECTED ON DASHBOARD
    next({ path: '/dashboard' });
  } else {
    // CONTINUE TO ANY ROUTES
    next();
  }
});


function isLoggedIn() {
  return localStorage.getItem('token') !== null;
}

export default router;

